import { WebLink } from '@news-mono/web-common'
import React from 'react'
import {
    StyledWestRewardsContainer,
    StyledWestRewardsLogo,
    StyledWestRewardsLogoContainer,
    StyledWestRewardsMessage,
    StyledWestRewardsWrapper,
} from './WestRewardsMessageStyled'

export const WestRewardsMessage: React.FC = () => {
    return (
        <StyledWestRewardsWrapper>
            <StyledWestRewardsContainer>

                <WebLink to="https://rewards.thewest.com.au/">
                    <StyledWestRewardsLogoContainer>
                        <StyledWestRewardsLogo />
                    </StyledWestRewardsLogoContainer>
                </WebLink>
                <StyledWestRewardsMessage>
                    <p>
                        Get exclusive offers, events and giveaways with West Rewards, included with all subscriptions.
                    </p>
                </StyledWestRewardsMessage>
            </StyledWestRewardsContainer>
        </StyledWestRewardsWrapper>
    )
}
